import { feature, flattenFeatures } from "@protontech/autofill/features/feature";
import { field, fieldAttrEmail, fieldAttrUsername, fieldAutocomplete, fieldAutocompleteEmail, fieldCC, fieldExotic, fieldIdentity, readonly, typeValid, value } from "@protontech/autofill/features/v1/abstract.field";
import { matchEmailValue, matchTelValue, matchUsernameValue } from "@protontech/autofill/utils/re";
import { isVisible } from "@protontech/autofill/utils/visible";

export const visibleReadonly = feature("visibleReadonly", { field, typeValid, readonly }, (p) => p.readonly && p.typeValid && isVisible(p.field, { opacity: true }));
export const attrMatch = feature("attrMatch", { field }, (p) => p.field.matches('[name="username"],[id="username"],[name="account"]'));
export const autocompleteUsername = feature("autocompleteUsername", { fieldAutocomplete }, (p) => Boolean(p.fieldAutocomplete?.includes("username")));
export const valueCandidate = feature("valueCandidate", { fieldValue: value }, (p) => p.value.length < 100);
export const valueEmail = feature("valueEmail", { valueCandidate, fieldValue: value }, (p) => p.valueCandidate && matchEmailValue(p.value));
export const valueTel = feature("valueTel", { valueCandidate, fieldValue: value }, (p) => p.valueCandidate && matchTelValue(p.value));
export const valueUsername = feature("valueUsername", { valueCandidate, fieldValue: value }, (p) => p.valueCandidate && matchUsernameValue(p.value));

export const usernameHiddenFeatures = flattenFeatures({
  attrMatch,
  autocompleteUsername,
  fieldAttrEmail,
  fieldAttrUsername,
  fieldAutocompleteEmail,
  fieldCC,
  fieldExotic,
  fieldIdentity,
  valueEmail,
  valueTel,
  valueUsername,
  visibleReadonly,
});
